module.exports = "/_next/static/images/b69df1dcf3d40a368ec0bb8b91b6cf7e-mail-icon.svg";